<!-- 编辑个人信息 -->
<template>
  <div class="edit">
    <!-- 导航栏 -->
    <van-nav-bar title="个人信息" fixed placeholder z-index="10" @click-left="goBack">
      <template #left>
        <img src="@/assets/img/position/back.png" class="back" />
      </template>
    </van-nav-bar>
    <!-- 信息栏 -->
    <div class="edit-info">
      <!-- 头像 -->
      <div class="info-user">
        <span>头像</span>
        <van-uploader :after-read="afterRead">
          <img :src="userImg" class="user-img" />
        </van-uploader>
      </div>
      <!-- 姓名 -->
      <div class="info-name">
        <div class="info-msg">
          <span>姓名</span>
          <div class="info-tips" v-show="name.length==0">
            <img src="@/assets/img/user/tips.png" class="tips" />
            <span>不能为空</span>
          </div>
        </div>
        <input type="text" placeholder="请输入姓名" class="input" v-model="name" />
      </div>
      <!--手机号-->
      <div class="info-name">
        <div class="info-msg">
          <span>手机号</span>
        </div>
        <input type="text" placeholder="请输入手机号" class="input" v-model="telphone" />
      </div>
      <!-- 性别 -->
      <div class="info-name">
        <div class="info-msg">
          <span>性别</span>
        </div>
        <van-radio-group v-model="radio">
          <van-radio name="1">
            <span :class="radio==1?'checked':''">男</span>
            <template #icon="props">
              <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
            </template>
          </van-radio>
          <van-radio name="2">
            <span :class="radio==2?'checked':''">女</span>
            <template #icon="props">
              <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
            </template>
          </van-radio>
        </van-radio-group>
      </div>
      <!-- 出生年月 -->
      <div class="info-degree">
        <div class="info-msg">
          <span>出生年月</span>
        </div>

        <span
          :class="value==''?'birth-select':'select'"
          @click="showTime=true"
        >{{value==''?'请选择':value}}</span>
        <van-popup v-model="showTime" round position="bottom">
          <van-datetime-picker
            v-model="currentDate"
            type="date"
            title="选择年月"
            :min-date="minDate"
            @cancel="showTime=false"
            @confirm="confirmTime"
          />
        </van-popup>
        <!-- <van-datetime-picker
          v-model="currentDate"
          type="year-month"
          :min-date="minDate"
          v-show="showTime"
          @cancel="showTime=false"
          @confirm="confirmTime"
        />-->
      </div>
      <!-- 学历选择 -->
      <div class="info-degree">
        <span>最高学历</span>
        <span :class="degree==''?'':'select'" @click="showPicker=true">{{degree==''?'请选择':degree}}</span>
        <van-popup v-model="showPicker" round position="bottom">
          <van-picker
            show-toolbar
            :columns="columns"
            @cancel="showPicker = false"
            @confirm="onConfirm"
            value-key="name"
          />
        </van-popup>
      </div>

      <!-- 退役士兵 -->
      <div class="info-degree">
        <span>是否退役军人</span>
        <span
          :class="serviceman==''?'':'select'"
          @click="solider=true"
        >{{serviceman==''?'请选择':serviceman}}</span>
        <van-popup v-model="solider" round position="bottom">
          <van-picker
            show-toolbar
            :columns="soliderList"
            @cancel="solider = false"
            @confirm="onConfirmSolider"
          />
        </van-popup>
      </div>
      <!-- 退役时间 -->
      <div class="info-degree">
        <div class="info-msg">
          <span>退役时间</span>
        </div>
        <span
          :class="timer==''?'birth-select':'select'"
          @click="showTimes=true"
        >{{timer==''?'请选择':timer}}</span>
        <van-popup v-model="showTimes" round position="bottom">
          <van-datetime-picker
            v-model="currentDate"
            type="date"
            title="选择年月"
            :min-date="minDate"
            @cancel="showTimes=false"
            @confirm="confirmTimes"
          />
        </van-popup>
        <!-- <van-datetime-picker
          v-model="currentDate"
          type="year-month"
          :min-date="minDate"
          v-show="showTimes"
          @cancel="showTimes=false"
          @confirm="confirmTimes"
        />-->
      </div>
    </div>
    <!-- 申请按钮 -->
    <div class="request-btn">
      <button class="btns" @click="editPersons">保存</button>
    </div>
  </div>
</template>

<script>
import {
  upLoad,
  editPerson,
  queryPreson,
  getKindArray,
  upLoaduserHead
} from "@/api/apiData";
import { dataURLtoFile, getImgToBase64 } from "@/until/upLoad";
import getFormat from "@/until/getFormatDate";
import { Toast } from "vant";
export default {
  components: {},
  data() {
    return {
      userImg: "", //上传的头像
      name: "", //姓名
      radio: "1", //性别选择
      telphone: "", //手机号
      activeIcon: require("@/assets/img/user/select.png"),
      inactiveIcon: require("@/assets/img/user/unselect.png"),
      showTime: false,
      showTimes: false,
      timer: "", //退役时间
      minDate: new Date(1800, 0, 1), //出生年月选择
      currentDate: new Date(),
      value: "", //选择的时间
      showPicker: false,
      columns: [],
      degree: "", //学历
      degreeId: "", //学历id
      solider: false, //退役军人
      serviceman: "",
      soliderList: ["退役士兵", "士官", "专业军官", "非退役军人"],
      soldier_type: "",
    };
  },
  computed: {},
  methods: {
    //返回上一页
    goBack() {
      this.$router.back();
    },
    // 图片上传完毕后
    afterRead(file) {
      //(file);
      upLoaduserHead({ avatar: file.content }).then(res => {
        //(res);
        if (res.code == 1) {
          this.userImg = res.data.url;
        }
      });
    },
    // 日期选择 点击确定
    confirmTime(val) {
      var that = this;
      that.value = getFormat(val,'yy-mm-ss');
      that.showTime = false;
    },
    // 退役时间选择
    confirmTimes(val) {
      var that = this;
      that.timer = getFormat(val, "yy-mm-ss");
      that.showTimes = false;
    },
    // 学历选择
    onConfirm(value) {
      this.degree = value.name;
      this.degreeId = value.category_id;
      this.showPicker = false;
    },
    // 是否退役军人
    onConfirmSolider(val) {
      var that=this;
      that.serviceman = val;
      //(val);
      switch (val) {
        case "非退役军人":
          that.soldier_type = 1;
          break;
        case "退役士兵":
          that.soldier_type = 2;
          break;
        case "士官":
          that.soldier_type = 3;
          break;
        case "专业军官":
          that.soldier_type = 4;
          break;
      }

      this.solider = false;
    },
    // 获取学历
    getEduction() {
      var that = this;
      getKindArray({ key: "education" }).then(res => {
        if (res.code == 1) {
          that.columns = res.data;
        }
      });
    },
    // 查询个人资料
    queryInfo() {
      var that = this;
      queryPreson().then(res => {
        //(res);
        if (res.code == 1) {
          that.name = res.data.name;
          that.radio = res.data.sex;
          that.telphone = res.data.mobile;
          that.value = res.data.birthday;
          that.userImg = res.data.avatar;
          that.degree = res.data.education_name;
          that.serviceman= res.data.soldier_type_name;
          that.timer=res.data.soldier_retired_time;
          that.degreeId=res.data.education;
          that.soldier_type=res.data.soldier_type
        }
      });
    },
    // 修改个人资料
    editPersons() {
      var that = this;
      let {
        name,
        radio,
        telphone,
        value,
        degreeId,
        soldier_type,
        timer,
        userImg
      } = that;

      var obj = {
        name: name.replace(/[, ]/g, ""),
        mobile: telphone.replace(/[, ]/g, ""),
        sex: radio,
        birthday: value,
        education: degreeId,
        soldier_retired_time:timer,
        soldier_type: soldier_type
      };
      //(obj);
      if (userImg == '') {
        Toast("请选择头像");
        return false;
      }
      if (name.replace(/[, ]/g, "").length == 0) {
        Toast("请输入姓名");
        return false;
      }
      if (!/^1[3456789]\d{9}$/.test(telphone)) {
        Toast("手机号码有误，请重填");
        return false;
      }
      if (radio == "") {
        Toast("请选择性别");
        return false;
      }
    
      if (value == "") {
        Toast("请选择生日日期");
        return false;
      }
        if (degreeId == "") {
        Toast("请选择最高学历");
        return false;
      }
      if (soldier_type == "") {
        Toast("请选择退役类型");
        return false;
      } else {
        if (soldier_type != 1&&timer=='') {
          Toast("请选择退役时间");
          return false;
        }
      }
      editPerson(obj).then(res => {
        if (res.code == 1) {
          Toast({
            overlay: true,
            message: "保存成功",
            forbidClick: true
          });
          setTimeout(() => {
            that.$router.back();
          }, 2000);
        } else {
          Toast(res.msg);
        }
      });
    }
  },
  created() {},
  mounted() {
    this.getEduction(); //获取学历
    this.queryInfo(); //查询个人信息
  }
};
</script>
<style lang='less' scoped>
// 信息栏
.edit-info {
  padding: 0 0.35rem;
  .info-user {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.3rem 0 0.1rem;
    border-bottom: 0.01rem solid rgba(229, 229, 229, 1);
    span {
      font-size: 0.26rem;
      font-weight: 400;
      line-height: 0.37rem;
      color: rgba(128, 128, 128, 1);
    }
    .user-img {
      width: 1rem;
      height: 1rem;
      border-radius: 50%;
    }
  }
  .info-name {
    display: flex;
    flex-direction: column;
    padding: 0.32rem 0;
    border-bottom: 0.01rem solid rgba(229, 229, 229, 1);
    .info-msg {
      display: flex;
      align-items: center;
      font-size: 0.26rem;
      font-weight: 400;
      line-height: 0.37rem;
      color: rgba(128, 128, 128, 1);
      .info-tips {
        display: flex;
        align-items: center;
        .tips {
          width: 0.24rem;
          height: 0.24rem;
          margin: 0 0.1rem;
        }
        span {
          font-size: 0.22rem;
          line-height: 0.24rem;
          color: rgba(255, 67, 67, 1);
        }
      }
    }
    // 性别
    /deep/.van-radio-group {
      display: flex;
      padding: 0.17rem 0 0;
      .van-radio {
        flex: 1;
        display: flex;
        align-items: center;
        .img-icon {
          width: 0.4rem;
          height: 0.4rem;
        }
        .van-radio__label {
          font-size: 0.3rem;
          line-height: 0.42rem;
          color: #cccccc;
        }
        .checked {
          font-weight: bold;
          color: rgba(51, 51, 51, 1);
        }
      }
    }
    // 出生日期
    .birth-select {
      font-size: 0.3rem;
      text-align: left;
      margin-top: 0.13rem;
      font-weight: 400;
      line-height: 0.42rem;
      color: rgba(204, 204, 204, 1);
    }
    // 日期选择器
    .van-picker {
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      z-index: 15;
      border-radius: 5% 5% 0 0;
    }
    .input {
      width: 100%;
      font-size: 0.3rem;

      line-height: 0.42rem;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      margin-top: 0.13rem;
      text-align: left;
    }
    .input::-webkit-input-placeholder {
      /* Chrome/Opera/Safari */
      font-size: 0.3rem;
      font-weight: 400;
      line-height: 0.42rem;
      color: rgba(204, 204, 204, 1);
    }

    .input::-moz-placeholder {
      /* Firefox 19+ */
      font-size: 0.3rem;
      font-weight: 400;
      line-height: 0.42rem;
      color: rgba(204, 204, 204, 1);
    }

    .input:-ms-input-placeholder {
      /* IE 10+ */
      font-size: 0.3rem;
      font-weight: 400;
      line-height: 0.42rem;
      color: rgba(204, 204, 204, 1);
    }

    .input:-moz-placeholder {
      /* Firefox 18- */
      font-size: 0.3rem;
      font-weight: 400;
      line-height: 0.42rem;
      color: rgba(204, 204, 204, 1);
    }
  }
  //   学历选择
  .info-degree {
    display: flex;
    flex-direction: column;
    padding: 0.32rem 0;
    border-bottom: 0.01rem solid #e5e5e5;
    span {
      font-size: 0.26rem;
      font-weight: 400;
      line-height: 0.37rem;
      color: #808080;
      text-align: left;
      min-height: 0.45rem;
    }
    span:nth-child(2) {
      margin-top: 0.13rem;
    }
    .select {
      font-size: 0.3rem;
      line-height: 0.42rem;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      text-align: left;
      margin-top: 0.13rem;
    }
  }
}
.edit-info::after {
  content: "";
  display: block;
  height: 1.2rem;
  width: 100%;
}
</style>